import React from "react";
import ChartMindPlusModuleSession from "./ChartMindPlusModuleSession";
import { DIFFERENTIAL_TCI_ID } from "./chartMindPlusSessionService";

/** Expected inbound ids from docs/CHARTMIND_PLUS_CMR_PREFLIGHT_REPORT.md. */
const DIFFERENTIAL_EXPECTED_FIELDS = [
  "dateOfBirth",
  "sex",
  "pmh",
  "medications",
  "allergies",
];

export default function ChartMindPlusDifferentialPage() {
  return (
    <ChartMindPlusModuleSession
      tciId={DIFFERENTIAL_TCI_ID}
      title="Differential Diagnosis"
      expectedFieldIds={DIFFERENTIAL_EXPECTED_FIELDS}
    />
  );
}
